import ABI from "src/contract-logic/abis/Bridge/MainCanonicalABI.json";
import { getCurrentContractAddresses } from "../../../configs/address";
import { getWeb3Sender, web3Reader } from "../../../wallet-connection";

const { MAIN_CANONICAL_TRANSACTION_CHAIN } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, MAIN_CANONICAL_TRANSACTION_CHAIN);
  }
  if (!contractReader) {
    throw new Error("Failed to create maincanonical contract reader");
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, MAIN_CANONICAL_TRANSACTION_CHAIN);
  }
  if (!contractSender) {
    throw new Error("Failed to create rent contract sender");
  }
  return contractSender;
}

async function getQueueLength() {
  const res = await getContractReader().methods.getQueueLength().call();
  return parseInt(res);
}

export default {
  ABI,
  ADDRESS: MAIN_CANONICAL_TRANSACTION_CHAIN,
  getContractSender,
  getQueueLength,
};
